/**
 * Handles manual double click events from normal click events
 * Used to handle double clicks on 3rd party components that don't natively support double clicks. Like FullCalendar
 * 
 */
export default {
  data() {
    return {
      dblClickCount: 0,
      dblClickDelay: 700,
      dblClickTimer: null
    }
  },
  methods: {

    // Handles the click event & returns true if the click was the 2nd in a quick double click process
    isClickDoubleClick() {
      this.dblClickCount++ 

      if(this.dblClickCount === 1) {
        var self = this
        this.dblClickTimer = setTimeout(function() {
          self.dblClickCount = 0
          self.dblClickTimer = null
        }, this.dblClickDelay)

      } else{
        // Successful double click
        clearTimeout(this.dblClickTimer)
        this.dblClickTimer = null
        this.dblClickCount = 0

        return true
      } 

      return false
    }
  }  
}